const stats = [
  {
    value: "36.6%",
    label: "Annual AI growth rate through 2030",
    icon: "ri-line-chart-line",
  },
  {
    value: "$15.7T",
    label: "AI\u2019s projected contribution to the global economy by 2030",
    icon: "ri-global-line",
  },
  {
    value: "72%",
    label: "Of organizations already using generative AI",
    icon: "ri-building-2-line",
  },
  {
    value: "133M",
    label: "New jobs AI is projected to create",
    icon: "ri-user-add-line",
  },
];

export default function StatsSection() {
  return (
    <section
      className="relative py-24 lg:py-28 overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, #3b1505 0%, #5c2008 40%, #78350f 75%, #92400e 100%)",
      }}
    >
      {/* Subtle radial glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(ellipse at 50% 100%, rgba(245,158,11,0.12) 0%, transparent 65%)",
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12">
        {/* Intro text */}
        <div className="text-center mb-16 lg:mb-20">
          <p className="font-serif italic text-lg md:text-xl lg:text-2xl text-amber-200/80 max-w-2xl mx-auto leading-relaxed">
            &ldquo;The numbers are staggering. The opportunity is real. And the time to get informed is now.&rdquo;
          </p>
          <div className="flex items-center justify-center gap-4 mt-6">
            <div className="h-px w-12 bg-amber-600/50" />
            <span className="font-sans text-xs tracking-widest uppercase text-amber-500/70 font-semibold">
              By the Numbers
            </span>
            <div className="h-px w-12 bg-amber-600/50" />
          </div>
        </div>

        {/* Stats grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0">
          {stats.map((stat, i) => (
            <div
              key={stat.value}
              className={`group flex flex-col items-center text-center px-8 py-10 lg:py-12 hover:bg-amber-700/20 transition-colors duration-300 ${
                i < stats.length - 1
                  ? "border-b sm:border-b-0 sm:border-r border-amber-700/40"
                  : ""
              } ${
                i === 1 ? "lg:border-r border-amber-700/40" : ""
              }`}
            >
              {/* Icon */}
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-amber-500/15 mb-6 group-hover:bg-amber-500/25 transition-colors duration-300">
                <i className={`${stat.icon} text-amber-400 text-lg`} />
              </div>

              {/* Big number */}
              <p
                className="font-serif font-bold text-amber-400 group-hover:text-amber-300 transition-colors duration-300 leading-none mb-4"
                style={{ fontSize: "clamp(2.5rem, 5vw, 3.5rem)" }}
              >
                {stat.value}
              </p>

              {/* Label */}
              <p className="font-sans text-sm text-amber-100/60 leading-relaxed max-w-[180px]">
                {stat.label}
              </p>
            </div>
          ))}
        </div>

        {/* Source note */}
        <p className="text-center font-sans text-xs text-amber-600/50 mt-10 tracking-wide">
          Sources: PwC Global AI Study &middot; McKinsey Global Institute &middot; World Economic Forum
        </p>
      </div>
    </section>
  );
}
